import { Button as AntdButton, ButtonProps as AntdButtonProps } from 'antd'

export interface ButtonProps extends AntdButtonProps {}

const Button: React.FC<ButtonProps> = (props) => {
  return <AntdButton disabled={props.loading === true} {...props} />
}

export default Button